/**
 * Enum for intermediary bank field keys used by the IntermediaryBankField component
 * These represent the underlying data structure keys received from the API
 */
export enum IntermediaryBankFieldKeys {
  SWIFT_CODE = 'swift_code',
  BANK_NAME = 'bank_name',
  BANK_ADDRESS = 'bank_address',
}

/**
 * Enum for translation keys used by the IntermediaryBankField component
 * These represent the i18n keys used for translating labels
 */
export enum TranslationKeys {
  INTERMEDIARY_BANK_PREFIX = 'afnIntermediaryBank',
  INTERMEDIARY_BANK_SWIFT_CODE = 'afnIntermediaryBankSwiftCode',
  INTERMEDIARY_BANK_NAME = 'afnIntermediaryBankName',
  INTERMEDIARY_BANK_ADDRESS = 'afnIntermediaryBankAddress',
}

/**
 * Type representing all possible intermediary bank field keys
 */
export type IntermediaryBankKey =
  | keyof typeof IntermediaryBankFieldKeys
  | string;

/**
 * Creates a translation key from an intermediary bank field key
 * @param key The field key from the intermediary bank object
 * @returns The translation key to use with the i18n system
 */
export const createTranslationKey = (key: IntermediaryBankKey): string => {
  if (key === IntermediaryBankFieldKeys.SWIFT_CODE) {
    return TranslationKeys.INTERMEDIARY_BANK_SWIFT_CODE;
  }
  if (key === IntermediaryBankFieldKeys.BANK_NAME) {
    return TranslationKeys.INTERMEDIARY_BANK_NAME;
  }
  if (key === IntermediaryBankFieldKeys.BANK_ADDRESS) {
    return TranslationKeys.INTERMEDIARY_BANK_ADDRESS;
  }

  const camelCaseKey = key.replace(/_([a-z])/g, (match, letter) =>
    letter.toUpperCase()
  );
  const pascalCaseKey =
    camelCaseKey.charAt(0).toUpperCase() + camelCaseKey.slice(1);

  return `${TranslationKeys.INTERMEDIARY_BANK_PREFIX}${pascalCaseKey}`;
};
